export const TestPanel = () => (
  <div className="mx-auto max-w-5xl p-8">
    <h2 className="mb-4 text-2xl tracking-tight text-[#1a2b6b]">Testovací panel</h2>
    <p className="text-gray-500">
      Testovací akce pro prototyp — implementace v přípravě. Brzy zpřístupní nahrání audia a přehrání hovoru,
      jakmile budou připraveny podpůrné endpointy.
    </p>
  </div>
);
